<template>
  <div class="login-wraper w-full h-full flex align-center justify-center lg:col-6 md:col-12">
    <div class="login-box bg-white px-3 pb-2 rounded lg:col-8 sm:col-12">
      <div class="login-heading flex flex-col flex-wrap text-left font-bold my-3 mx-1">
        <h1 class="font-opacity-lg">Redefinir Senha</h1>
        <p class="font-opacity-md">Informe sua nova senha.</p>
      </div>
      <SmartInput
        name="newPassword"
        v-model="password"
        class="mb-2"
        label="Nova Senha"
        type="password"
        v-validate="'required|min:8|newPassword'"
        :error="errors.first('newPassword')"
        placeholder="Digite sua nova senha"
      />
      <SmartInput
        name="confirmPassword"
        v-model="confirmPassword"
        class="mb-3"
        label="Confirme nova senha"
        type="password"
        :error="isPasswordNotEqual"
        v-validate="'required|min:8'"
        placeholder="Confirme sua nova senha"
      />
      <SmartButton
        :disabled="!formIsValid"
        :loading="isLoading"
        class="lg:col-12 mb-3"
        @click="redefinePassword">
        Redefinir Senha
      </SmartButton>
      <a href="#"
         class="text-brand-secondary smart-link block text-center mb-1"
         @click='returnLogin'>
        Fazer login</a>
      <SmartModal
        v-if="modal"
        v-bind="modal"
        @close='modal.action'>
        {{ modal.text }}
      </SmartModal>
    </div>
  </div>
</template>
<script>
// @flow
import { mapActions } from 'vuex';

export default {
  name: 'NewPassword',
  data: () => ({
    password: '',
    confirmPassword: '',
    isLoading: false,
    modal: null
  }),
  methods: {
    ...mapActions({
      newPassword: 'auth/newPassword',
      checkUser: 'auth/checkUser'
    }),
    redefinePassword() {
      this.isLoading = true;
      const sendNewPassword = {
        token: this.token,
        body: {
          reset_form: {
            password: this.password
          }
        }
      };
      this.newPassword(sendNewPassword)
        .then(({ message }) => {
          this.modal = {
            type: 'success',
            title: 'Senha Alterada!',
            icon: 'accepted',
            buttonText: 'Realizar login!',
            text: message,
            action: this.pushToLogin
          };
        })
        .catch(({ data }) => {
          let error = data.error || 0;
          let message = data.message || 'Ocorreu um erro inesperado. Por favor, tente novamente';
          let trans = {
            0: 'Link inválido',
            'LastPasswordException': 'Nova senha não permitida'
          };
          let buttonText = {
            0: 'Reenviar Link',
            'LastPasswordException': 'Ok, entendi!'
          }
          this.modal = {
            type: 'danger',
            title: trans[error],
            icon: 'refused',
            buttonText: buttonText[error],
            text: data.message,
            action: error === 0 ? this.pushToSendPassword : () => {
              this.modal = null;
              this.password = '';
              this.confirmPassword = '';
            }
          };
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    returnLogin() {
      this.$router.push({ name: 'Login' });
    },
    pushToLogin() {
      this.$router.push({ name: 'Login' });
    },
    pushToSendPassword() {
      this.$router.push({ name: 'ResetPassword' });
    }
  },
  computed: {
    token() {
      return this.$route.params.token;
    },
    isPasswordNotEqual() {
      if (!this.isPasswordEqual) {
        return 'As duas senhas devem ser iguais!';
      }
      return '';
    },
    isPasswordEqual() {
      return this.password === this.confirmPassword;
    },
    passwordHasMinLenght() {
      return this.password.length >= 8 && this.confirmPassword.length >= 8;
    },
    hasPasswordAndConfirmPassword() {
      return Boolean(this.password && this.confirmPassword);
    },
    isPasswordValid() {
      return !this.errors.first('newPassword');
    },
    formIsValid() {
      return this.hasPasswordAndConfirmPassword
      && this.isPasswordEqual
      && this.passwordHasMinLenght
      && this.isPasswordValid;
    }
  },
  mounted() {
    this.checkUser(this.token);
  }
};
</script>
